module.exports = __webpack_public_path__ + "img/2_uk.66837bf1.svg";